<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="container-fluid mt-3">
  <runner-journal-view [clientUserId]="clientUserId" [isCoachView]="hasCoachRole"></runner-journal-view>
</div>